import langDict from './lang.js';
export default {
    loadingState: false,
    menuOptions : [],
    // plus utilisé nul part
    options: {
        DefaultBackgroundFile1: null,
        DefaultBackgroundFile2: null,
        dashboardName: 'Automation dashboard',
    },
    menuActivated: '0',
    menuOptionIndexed: {},
    hasStatusAvailable: true,
    dataStoreVersion: null,
    status: {
        online: true,
        update: false,
        focused: true,
    },
    burgerClosed: localStorage.menuClosed ? JSON.parse(localStorage.menuClosed) : false,
    langSelected: 'en',
    langDict: langDict,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/state.js
// module id = null
// module chunks = 